import { ISyncCoreApi } from '@edgebox/sync-core-rest-client';
import React from 'react';
import { NameLoading } from '../../../Components/BrandPresenceSkeleton';
import { loadHealthCheckReferenceDataByKey } from './HealthCheckReferenceData';

/**
 * A health check, named by the name Sync Core gives it. While the name is being read it shows as
 * loading; a check whose name cannot be read, or cannot be asked for (no key, no Sync Core), shows
 * `fallback`. The key only stands in where a screen passes it as its `fallback`.
 */
export function HealthCheckNameReference({
  api,
  healthCheckKey,
  fallback = '—',
}: {
  api?: ISyncCoreApi;
  healthCheckKey?: string;
  fallback?: string;
}) {
  // The name read for one key: a name read for a key shown before is not this check's.
  const [read, setRead] = React.useState<{ healthCheckKey: string; name?: string }>();

  React.useEffect(() => {
    if (!api || !healthCheckKey) {
      return;
    }

    let active = true;

    void (async () => {
      const referenceData = await loadHealthCheckReferenceDataByKey(api, healthCheckKey);
      if (!active) {
        return;
      }

      setRead({ healthCheckKey, name: referenceData.named ? referenceData.name : undefined });
    })();

    return () => {
      active = false;
    };
  }, [api, healthCheckKey]);

  if (!api || !healthCheckKey) {
    return <>{fallback}</>;
  }

  if (read?.healthCheckKey !== healthCheckKey) {
    return <NameLoading />;
  }

  return <>{read.name || fallback}</>;
}
